import { StyledSuggestion } from "./styles";

export const EmailSuggestion = ({
    text,
    onClick,
    isVisible,
}: {
    text: string;
    onClick: () => void;
    isVisible: boolean;
}) => {
    if (!isVisible) {
        return null;
    }
    return (
        <StyledSuggestion
            key={text}
            onClick={onClick}
        >
            {text}
        </StyledSuggestion>
    );
};
